import React, { createContext, useContext, useState } from 'react'

import { AuthContext } from './AuthContext';
import { HomeContext } from './HomeContext';
// import { OPERATION_FAILED_MESSAGE } from 'actions';
import {
    getDocuments,
    removeDocumentsTask,
    uploadDocumentsTask,
    uploadTaskDashboard,
    generateTradeTrust,
    getTradeTrust,
    getDocumentTaskDefault,
    uploadDocumentTaskDefault,
    removeDocumentsDefault,
    getDocumentSignatureList,
    getDocumentSignatureStatuses,
    getEthereum,
    getParties,
    transferHolder,
    nominateOwnerShip,
    directEndorsementHolder,
    directEndorsementOwner,
    getEndorsementChain,
    directEndorsementChain,
    surrenderDocument,
    commentPreviewDocument,
    getDocumentVersions,
    updatePartners,
} from 'actions/documents';
import { StatusTradeTrust } from 'actions';

export const DocumentsContext = createContext();

export const DocumentsContextProvider = ({ children }) => {
    const { loggedInUser } = useContext(AuthContext);
    const { setCurrentStatus } = useContext(HomeContext);
    const [documents, setDocuments] = useState([]);
    const [documentsOfTask, setDocumentsOfTask] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalDocuments, setTotalDocuments] = useState(0);
    const [documentPermission, setDocumentPermission] = useState(false);
    const [permissionTask, setPermissionTask] = useState([]);
    const [permissionDefaultTask, setPermissionDefaultTask] = useState([]);
    const [functionsTask, setFunctionsTask] = useState([]);
    const [setDocument] = useState();
    const [rawDocument, setRawDocument] = useState(null);
    const [payloadDocument, setPayloadDocument] = useState({});
    const [parties, setParties] = useState(null);
    const [securityToken, setSecurityToken] = useState();
    const [documentInfo, setDocumentInfo] = useState();
    const [endorsementChain, setEndorsementChain] = useState([]);
    const [documentVersions, setDocumentVersions] = useState([]);
    const [listComment, setListComment] = useState([]);
    const [documentDetail, setDocumentDetail] = useState([])
    const {
        setLoading,
        // setNotificationMessage,
        // setNotificationType,
        setPleaseAwait,
    } = useContext(HomeContext);
    const [currentHolderOwner, setCurrentHolderOwer] = useState();
    const handleException = error => {
        // const data = error?.response?.data;
        setLoading(false);
        // setNotificationType('error');
        // setNotificationMessage((data && (data.message || data.error)) || OPERATION_FAILED_MESSAGE);
        console.log(error)
    }

    const doGetDocuments = async (shipmentId, params, callback) => {
        // if (documents && documents.length === 0) {
        try {
            setLoading(true);
            const response = await getDocuments(shipmentId, params, loggedInUser);
            const { data, status } = response;
            if (status === 200) {
                // if (params.page !== currentPage) {
                setDocuments(data.items || []);
                // } else {
                //     setDocuments(data.items || []);
                // }
                // // setDocuments(data.items);
                // setTotalPages(data.totalPage);
                // setCurrentPage(data.currentPage);
                // setTotalDocuments(data.totalItems);
                doGetDocumentTaskDefault(shipmentId);
                setPermissionTask(data.permission.taskFunctions);
                if (callback) callback(data);
            }
            setLoading(false);
        } catch (error) {
            handleException(error);
        }
    }
    // }

    const doRemoveDocumentsTask = async (taskId, payload, callback) => {
        if (taskId) {
            try {
                setLoading(true);
                const response = await removeDocumentsTask(taskId, payload, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    setDocumentsOfTask(data);
                    if (callback) callback();
                }
                setLoading(false);
            } catch (error) {
                handleException(error)
            }
        }

    }

    const doUpdatePartners = async (documentId, payload, callback) => {
        if (documentId) {
            try {
                setLoading(true);
                const response = await updatePartners(documentId, payload, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    if (callback) callback(data);
                }
            } catch (error) {
                handleException(error);
            }
            setLoading(false);
        }
    }

    const doSurrenderDocument = async (documentId, payload, header, callback) => {
        try {
            if (documentId) {
                setLoading(true);
                const response = await surrenderDocument(documentId, payload, header, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    if (callback) callback(data?.result);
                }
                setLoading(false);
            }
        } catch (error) {
            handleException(error);
        }
    }

    const doRemoveDocumentsDefault = async (taskId, payload, callback) => {
        if (taskId) {
            try {
                setLoading(true);
                const response = await removeDocumentsDefault(taskId, payload, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    setDocumentsOfTask(data);
                    if (callback) callback();
                }
                setLoading(false);
            } catch (error) {
                handleException(error)
            }
        }

    }

    const doGetEndorsementChain = async (params, header, callback) => {
        try {
            const response = await getEndorsementChain(params, header, loggedInUser);
            const { data, status } = response;
            if (status === 200) {
                setEndorsementChain(data);
                if (callback) callback(data);
            }
        } catch (error) {
            // handleException(error)
        }
    }

    const doUploadDocumentsTask = async (taskId, payload, callback) => {
        if (taskId) {
            try {
                setLoading(true);
                const response = await uploadDocumentsTask(taskId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
                setLoading(false);
            } catch (error) {
                handleException(error)
            }
        }
    }

    const doCommentPreviewDocument = async (documentId, payload, callback) => {
        if (documentId) {
            try {
                setLoading(true);
                const response = await commentPreviewDocument(documentId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
                setLoading(false);
            } catch (error) {
                handleException(error)
            }
        }
    }

    const doUploadTaskDashboard = async (taskId, payload, callback) => {
        if (taskId) {
            try {
                setLoading(true);
                const response = await uploadTaskDashboard(taskId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
                setLoading(false);
            } catch (error) {
                handleException(error)
            }
        }
    }

    const doGenerateTradeTrust = async (taskId, fileName, shipmentId, isLoading, callback) => {
        try {
            if (isLoading)
                setLoading(true);
            const response = await generateTradeTrust(taskId, fileName, shipmentId, loggedInUser);
            const { data, status } = response;
            if (isLoading)
                setLoading(false);
            return callback(status === 200 && data.success);
        } catch (error) {
            handleException(error)
        }
        if (isLoading)
            setLoading(false);
        return callback(false);
    }

    const doGetTradeTrust = async (taskId, ids, isLoading, callback) => {
        try {
            if (isLoading)
                setLoading(true);
            const response = await getTradeTrust(taskId, ids, loggedInUser);
            const { data, status } = response;
            if (status === 200) {
                callback(data);
            }
        } catch (error) {
            handleException(error)
        }
        if (isLoading)
            setLoading(false);
    }

    const doGetDocumentTaskDefault = async (shipmentId) => {
        try {
            const response = await getDocumentTaskDefault(shipmentId, loggedInUser);
            const { data, status } = response;
            if (status === 200) {
                setDocuments(old => [...data.items, ...old]);
                setPermissionDefaultTask(data.permission.shipmentFunctions);
            }
        } catch (error) {
            handleException(error)
        }
    }

    const doUploadDocumentsTaskDefault = async (taskId, payload, callback) => {
        if (taskId) {
            try {
                setLoading(true);
                const response = await uploadDocumentTaskDefault(taskId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
            } catch (error) {
                handleException(error)
            }
            setLoading(false);
        }
    }

    const doTransferHolder = async (documentId, payload, callback) => {
        try {
            setLoading(true);
            if (documentId) {
                const response = await transferHolder(documentId, payload, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    if (callback) callback(data);
                }
            }
        } catch (error) {
            setCurrentStatus(StatusTradeTrust.HOLDER_TRANSFER_FAILED);
            handleException(error);
        }
        setLoading(false);
    }

    const doNominateOwnerShip = async (documentId, payload, callback) => {
        try {
            if (documentId) {
                setLoading(true);
                const response = await nominateOwnerShip(documentId, payload, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    if (callback) callback(data);
                }
            }
        } catch (error) {
            setCurrentStatus(StatusTradeTrust.NEW_OWNER_NOMINATION_FAILED);
            handleException(error);
        }
        setLoading(false);
    }

    const doDirectEndorsementChain = async (documentId, payload, partyAccount, typeBlockChain, orgId, callback) => {
        try {
            setLoading(true);
            const response = await directEndorsementChain(documentId, payload, partyAccount, typeBlockChain, orgId, loggedInUser);
            const { data, status } = response;
            if (status === 200) {
                if (callback) callback(data);
            }
        } catch (error) {
            setCurrentStatus(StatusTradeTrust.OWNER_ENDORSEMENT_FAILED);
            handleException(error);
        }
        setLoading(false);
    }

    const doDirectEndorsementHolder = async (docId, payload, callback) => {
        if (docId) {
            try {
                setLoading(true);
                const response = await directEndorsementHolder(docId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
            } catch (error) {
                // setCurrentStatus(StatusTradeTrust.OWNER_ENDORSEMENT_FAILED);
                handleException(error)
            }
            setLoading(false);
        }
    }

    const doDirectEndorsementOwner = async (docId, payload, callback) => {
        if (docId) {
            try {
                setLoading(true);
                const response = await directEndorsementOwner(docId, payload, loggedInUser);
                const { status } = response;
                if (status === 200) {
                    if (callback) callback();
                }
            } catch (error) {
                handleException(error)
            }
            setLoading(false);
        }
    }

    const doGetParties = async (payload, header, callback) => {
        try {
            const response = await getParties(payload, header, loggedInUser);
            if (response.status === 200) {
                setParties(response?.data?.result);
                if (response?.data?.result?.currentHolder !== currentHolderOwner?.currentHolder || response?.data?.result.currentOwner !== currentHolderOwner?.result?.currentOwner) {
                    setPleaseAwait(false);
                    if(callback) callback(true);
                    return true;
                };
            }
        } catch (error) {
            handleException(error);
        }

    }

    const doGetEthereum = async (params, header, callback) => {
        setLoading(true);
        try {
            const response = await getEthereum({
                dltID: params.dltID,
                isDemo: false,
            }, header, loggedInUser);

            const { data, status } = response;
            if (status === 200) {
                setRawDocument(data?.result);
                if (callback) callback(data);
                setSecurityToken({
                    tokenRegistryAddress: data?.result?.rawDocument?.issuers[0]?.tokenRegistry,
                    merkleRoot: data?.result?.wrappedDocument?.signature?.merkleRoot,
                });
                const partiesRes = await getParties({
                    dltID: params.dltID,
                    isDemo: false,
                    tokenRegistryAddress: data?.result?.rawDocument?.issuers[0]?.tokenRegistry,
                    merkleRoot: data?.result?.wrappedDocument?.signature?.merkleRoot,
                    organizationId: params.orgId,
                    walletPassword: params.walletPassword,
                }, header, loggedInUser);
                setCurrentHolderOwer({
                    currentHolder: partiesRes?.data?.result?.currentHolder,
                    currentOwner: partiesRes?.data?.result?.currentOwner
                })

                setPayloadDocument({
                    tokenRegistryAddress: data?.result?.rawDocument?.issuers[0]?.tokenRegistry,
                    merkleRoot: data?.result?.wrappedDocument?.signature?.merkleRoot,
                    organizationId: params.orgId,
                    walletPassword: params.walletPassword,
                });
                if (partiesRes.status === 200) {
                    setDocumentInfo({
                        tokenRegistryAddress: data?.result?.rawDocument?.issuers[0]?.tokenRegistry,
                        merkleRoot: data?.result?.wrappedDocument?.signature?.merkleRoot,
                        organizationId: params?.orgId,
                        walletPassword: params?.walletPassword
                    });
                    setParties(partiesRes?.data?.result);
                }

            }
        } catch (error) {
            handleException(error)
        }
        setLoading(false);
    }


    const doGetDocumentsSignatureList = async (shipmentId, callback) => {
        if (shipmentId) {
            try {
                setLoading(true);
                const response = await getDocumentSignatureList(shipmentId, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    if (response?.data?.docs?.length > 0) {
                        const arrayStatus = await Promise.all(
                            // eslint-disable-next-line array-callback-return
                            response?.data?.docs?.map((item) => {
                                doGetDocumentSignatureStatuses(item?._id)
                            }),
                        )
                        if (callback) callback(data.docs, arrayStatus)
                    }
                }
                setLoading(false);
            } catch (error) {
                handleException(error);
            }
        }
    }

    const doGetDocumentSignatureStatuses = async (documentId, callback) => {
        if (documentId) {
            try {
                setLoading(true);
                const response = await getDocumentSignatureStatuses(documentId, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    setDocument(data || []);
                    if (callback) callback(data.docs);
                }
                setLoading(false);
            } catch (error) {
                handleException(error);
            }
        }
    }

    const doGetDocumentSignatureDetailVersion = async (documentId, callback) => {
        if (documentId) {
            try {
                setLoading(true);
                const response = await getDocumentVersions(documentId, loggedInUser);
                const { data, status } = response;
                if (status === 200) {
                    setDocumentDetail(data || {})
                    setDocumentVersions(data.versions || []);
                    setListComment(data.comments || []);
                    if (callback) callback(data);
                }
                setLoading(false);
            } catch (error) {
                handleException(error);
            }
        }
    }

    // const doGetDocumentDetail = async (documentId, orgId, callback) => {
    //     if (documentId) {
    //         try {
    //             setLoading(true);
    //             const response = await getDocument(documentId, orgId, loggedInUser);
    //             const { data, status } = response;
    //             if (status === 200) {
    //                 setDocumentDetail(data)
    //                 if (callback) callback(data);
    //             }
    //             setLoading(false);
    //         } catch (error) {
    //             handleException(error);
    //         }
    //     }
    // }

    return (
        <DocumentsContext.Provider
            value={{
                documents,
                document,
                documentsOfTask,
                currentPage,
                securityToken,
                endorsementChain,
                totalPages,
                totalDocuments,
                documentPermission,
                permissionTask,
                permissionDefaultTask,
                functionsTask,
                rawDocument,
                documentInfo,
                payloadDocument,
                parties,
                documentVersions,
                listComment,
                documentDetail,
                setDocumentDetail,
                setFunctionsTask,
                setTotalDocuments,
                setDocumentPermission,
                setDocumentsOfTask,
                setDocuments,
                setCurrentPage,
                setTotalPages,
                setDocumentVersions,
                doGetDocuments,
                doRemoveDocumentsTask,
                doRemoveDocumentsDefault,
                doUploadDocumentsTask,
                doUploadTaskDashboard,
                doCommentPreviewDocument,
                doGenerateTradeTrust,
                doTransferHolder,
                doSurrenderDocument,
                doGetTradeTrust,
                doNominateOwnerShip,
                doGetDocumentTaskDefault,
                doUploadDocumentsTaskDefault,
                doDirectEndorsementHolder,
                doDirectEndorsementOwner,
                doGetParties,
                doUpdatePartners,
                doGetDocumentsSignatureList,
                doGetDocumentSignatureStatuses,
                setDocument,
                doGetEthereum,
                doDirectEndorsementChain,
                doGetEndorsementChain,
                doGetDocumentSignatureDetailVersion,
                // doGetDocumentDetail
            }}
        >
            {children}
        </DocumentsContext.Provider>
    )
}
